// Implementation dashboard types and constants

export type RAGStatus = 'Red' | 'Amber' | 'Green'

export type SortCol = 'key' | 'summary' | 'status' | 'shortStatus' | 'rag' | 'assignee' | 'dueDate' | 'created' | 'days' | 'handoverDate'
export type SortDir = 'asc' | 'desc'

export const STATUS_COLORS: Record<string, string> = {
  'Awaiting Allocation': '#6B7280',
  'Discovery': '#3B82F6',
  'Waiting for Partner Forms': '#8B5CF6',
  'Waiting for Partner - External': '#7C3AED',
  'Waiting for Customer - External': '#A78BFA',
  'Waiting for Frankie Internal': '#60A5FA',
  'Paused': '#94A3B8',
  'Setup and Config': '#F59E0B',
  'Build and Test (UAT)': '#F97316',
  'Production Ready (PVT)': '#06B6D4',
  'Go Live / Hypercare': '#10B981',
  'Transitions to Support / CS': '#22C55E',
}

export const STATUS_ORDER = Object.keys(STATUS_COLORS)

/** Statuses that pause the execution clock — time here is excluded from activeDays */
export const WAITING_STATUSES = new Set([
  'Awaiting Allocation',
  'Waiting for Partner Forms',
  'Waiting for Partner - External',
  'Waiting for Customer - External',
  'Paused',
])

/** Target completion days by project size (KPI thresholds) */
export const SIZE_KPI_DAYS: Record<string, number> = {
  'Small': 30,
  'Medium': 60,
  'Large': 90,
  'Extra Large': 120,
}

export const RAG_CONFIG: Record<RAGStatus, { color: string; bg: string; border: string }> = {
  Red: { color: '#ef4444', bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.25)' },
  Amber: { color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.25)' },
  Green: { color: '#22c55e', bg: 'rgba(34,197,94,0.12)', border: 'rgba(34,197,94,0.25)' },
}

export const DURATION_RANGES = [
  { label: '<40d', color: '#22c55e', description: 'On track' },
  { label: '40-69d', color: '#f59e0b', description: 'Monitor' },
  { label: '70-89d', color: '#f97316', description: 'At risk' },
  { label: '90d+', color: '#ef4444', description: 'Stalled' },
]

export function durationColor(days: number, threshold?: number): string {
  if (threshold !== undefined) {
    const pct = days / threshold
    if (pct < 0.7) return '#22c55e'
    if (pct < 0.9) return '#f59e0b'
    if (pct < 1.0) return '#f97316'
    return '#ef4444'
  }
  if (days < 40) return '#22c55e'
  if (days < 70) return '#f59e0b'
  if (days < 90) return '#f97316'
  return '#ef4444'
}
